module.exports = __webpack_public_path__ + "static/RingSavvyTagline-BlackGreen-8b2f8d29095755f43ae28e9b9e59dfe5.svg";